import {NgModule} from '@angular/core';
import {TrustUrlPipe} from './util/trustUrl.pipe';

@NgModule({
    imports: [],
    declarations: [
        TrustUrlPipe
    ],
    exports: [
        TrustUrlPipe
    ]
})
export class SharedModule {
}
